<template>
  <div class="content">
    <controllbar></controllbar>
    <div class="body">
      <div v-for="(item, key) in helpItems" :key="item.index">
        <div class="help_list">
          <div class="helpDate" v-text="item.date" />
          <div class="helpTitle" v-text="item.title" />
          <div class="helpText" v-text="item.message" />
        </div>
        <hr v-if="key < helpItems.length - 1" />
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setNotifications(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controllbar from './controllbar.vue'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import Pagination from 'vue-pagination-2'

export default {
  data() {
    return {
      falseWord: '',
      showFalseModal: false,
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0
    }
  },
  components: {
    controllbar,
    falseModalWindow,
    loadingModalWindow,
    Pagination
  },
  computed: {
    notificationList() {
      return this.$store.state.notificationsTenant.notificationsList
    },
    helpItems() {
      var items = []
      for (let msg of this.notificationList) {
        var item = Object()
        item.title = msg.title
        item.message = msg.message
        var d = new Date(msg.updateDateTime)
        item.date =
          d.getFullYear() +
          '年' +
          (d.getMonth() + 1) +
          '月' +
          d.getDate() +
          '日 ' +
          d.toLocaleTimeString()
        items.push(item)
      }
      return items
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.notificationsTenant.total
      ) {
        return this.$store.state.notificationsTenant.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >=
        this.$store.state.notificationsTenant.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.notificationsTenant.total / this.pageSize
      )
      return last === 0 ? 1 : last
    }
  },
  async created() {
    this.setNotifications(0)
  },
  methods: {
    close(e) {
      this.showFalseModal = false
    },
    async setNotifications(pageNo) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('notificationsTenant/setNotifications', {
          pageNo: pageNo
        })
        this.$store.state.prevPageNo = pageNo
        if (this.isOverPage) {
          this.page = this.lastPage
        } else {
          this.page = pageNo + 1
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_120001
        let eventType = 3
        let reason = 'MSGCRD0106 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRD0106.name +
            this.errorMsg.MSGCRD0106.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.body {
  width: 100%;
  height: calc(100% - 108px);
  overflow-y: scroll;
}
.content {
  width: calc(100% - 262px);
}
.bottom {
  width: calc(100% - 262px);
}
.bottom >>> table tr td a img {
  width: 20px;
}
.helpDate {
  color: #9b9b9b;
  padding-bottom: 10px;
}
.helpTitle {
  color: #00b0a8;
  font-weight: bold;
  padding-bottom: 10px;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.helpText {
  word-wrap: break-word;
  white-space: pre-wrap;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/notifications/notificationsList.vue